import { AppStatus } from "api/app-status";
import { GetUserById, ProfileRow } from "api/profile";
import { FriendData, FriendRequest } from "api/friend";
import { VehicleType, VoteByEventId, VoteType } from "api/vote";
import { UserAuth } from "store/userSlice";
import { AugmentedEvent, AugmentedGroup } from "store/appDataSlice";

export const appStatus: AppStatus = {
  announcement: {
    date: 1649959636, // April 14, 2022 6:07:16 PM
    text: "Test announcement",
    type: "info",
    active: true,
  },
  changelog: {
    changes: [],
    version: "1.0.0",
  },
  maintenance: {
    text: "We are fixing some issue",
    active: false,
  },
  showFeedback: true,
  update: {
    changes: [],
    mobileAppText: "Updating app...",
    webAppText: "Updating app...",
    version: "1.0.0",
  },
};

export const authUser: UserAuth = {
  email: "user1@test.com",
  id: 1,
  profileCreated: true,
  provider: "email",
};

export const events: AugmentedEvent[] = [
  {
    id: 1,
    updated_at: "2022-06-01T17:50:45.572708+00:00",
    created_at: "2022-06-01T17:50:45.572708+00:00",
    group_id: 1,
    name: "Event 1",
    details: "Here you can find the url: https://www.youtube.com. We are waiting for you!",
    icon: {
      id: "coffee",
      name: "Hot Beverage",
      native: "☕",
      unified: "2615",
      keywords: ["coffee", "caffeine", "latte", "espresso"],
      shortcodes: ":coffee:",
    },
    start_date: "2022-06-10T21:00:00+00:00",
    vote_before: "2022-06-05T21:00:00+00:00",
    status: "open",
    location: {
      coordinates: {
        lat: 45.1262795,
        lng: 25.742575,
      },
      name: "Câmpina 105600, Romania",
    },
    participants_limit: null,
    end_date: "2022-06-15T22:00:00+00:00",
    stale: true,
    weather: null,
    vote_reminder_uuid: null,
    updated_by: 1,
  },
];

export const groups: AugmentedGroup[] = [
  {
    avatar: null,
    id: 1,
    name: "Group 1",
    users: [1, 2, 3],
    admins: [1],
    stale: false,
    roles: {},
  },
  {
    avatar: null,
    id: 2,
    name: "Group 2",
    users: [1, 2, 4],
    admins: [2],
    stale: false,
    roles: {},
  },
];

export const groupsUsers: GetUserById[] = [
  { avatar: null, name: "User 1", tag: "user.1#1000", uid: 1 },
  { avatar: null, name: "User 2", tag: "user.2#1000", uid: 2 },
  { avatar: null, name: "User 3", tag: "user.3#1000", uid: 3 },
  { avatar: null, name: "User 4", tag: "user.4#1000", uid: 4 },
  { avatar: null, name: "User 5", tag: "user.5#1000", uid: 5 },
];

export const friends: FriendData[] = [
  {
    avatar: null,
    id: 2,
    name: "User II",
    uid: 2,
    tag: "user.ii#1000",
  },
];

export const friendRequests: FriendRequest[] = [
  {
    avatar: null,
    id: 3,
    uid: 3,
    name: "User III",
    sent_by_uid: 1,
  },
  {
    avatar: null,
    id: 4,
    name: "User IV",
    uid: 4,
    sent_to_uid: 1,
  },
];

export const userProfile: ProfileRow = {
  avatar: null,
  created_at: "2022-06-01T22:00:00+00:00",
  id: 1,
  tag: "user.i#1000",
  name: "User I",
  lower_case_name: "user i",
  updated_at: "2022-06-01T22:00:00+00:00",
  uuid: "1",
};

export const votes: VoteByEventId[] = [
  {
    event_id: 1,
    id: 1,
    type: VoteType.PARTICIPATING,
    uid: 1,
    vehicle_details: {
      type: VehicleType.MID_SIZE_CAR,
      availableSeats: 5,
    },
    passengers: [],
    joined_on: "2022-06-02T17:00:15.267503+00:00",
    updated_at: "2022-06-02T17:00:15.267503+00:00",
  },
  {
    event_id: 1,
    id: 2,
    type: VoteType.PENDING,
    uid: 2,
    vehicle_details: null,
    passengers: [],
    joined_on: "2022-06-02T17:00:15.267503+00:00",
    updated_at: "2022-06-02T17:00:15.267503+00:00",
  },
];
